<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Users">

<!-- FILTERS -->
<div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card" >
        <div class="card-header" (click)="changeFilterOpenState()" style="cursor:pointer">
          <i class="fa fa-filter"></i> Filtres
          <div class="pull-right">
            @if (isFilterOpen) {
              <i class="fa fa-chevron-down"></i>
            } @else {
              <i class="fa fa-chevron-left"></i>
            }
          </div>
        </div>
        <div class="card-body" [collapse]="!isFilterOpen">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">ID</label>
                <input class="form-control" placeholder="id" type="text" [(ngModel)]="requestFilters.id">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Name</label>
                <input class="form-control" placeholder="Name" type="text" [(ngModel)]="requestFilters.nickname">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Email</label>
                <input class="form-control" placeholder="Email" type="text" [(ngModel)]="requestFilters.email">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name">Facebook ID</label>
                <input class="form-control" placeholder="Facebook ID" type="text" [(ngModel)]="requestFilters.facebook_id">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Bought Credits (min)</label>
                <input class="form-control" placeholder="Bought Credits min" type="number" [(ngModel)]="requestFilters.bought_credits_min">
              </div>
            </div>
          </div>
          <div class="filters-buttons">
            <button [disabled]="isLoading" class="btn btn-sm btn-primary" (click)="onClickFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button [disabled]="isLoading" class="btn btn-sm btn-danger" (click)="onClickResetFilters()"><i class="fa fa-ban"></i> Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-user-add-currency-modal #addCurrencyModal [userId]="selectedUserId"></app-user-add-currency-modal>
<app-user-add-experience-modal #addExperienceModal [userId]="selectedUserId"></app-user-add-experience-modal>

<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i> Utilisateurs
        </div>
        <div class="card-body">
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>User Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Created At</th>
                <th>Credit</th>
                <th>Bought credit</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (user of users; track user.userId; let i = $index) {
                <tr>
                  <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                  <td>{{ user.userId }}</td>
                  <td>{{ user.firstname || 'Guest' + user.userId }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.createdAtTimestamp !== 0 ? dateService.getDateFromatted(user.createdAtTimestamp) : '-' }}</td>
                  <td>{{ user.getCurrencyQuantity(UserCurrencyType.Credit) }}</td>
                  <td>{{ user.shopBuyCredits }}</td>
                  <td>
                    @if (user.isOnline()) {
                      <span class="badge bg-success">Online</span>
                    }
                    @if (user.isBanned) {
                      <span class="badge bg-danger">Banned</span>
                    }
                    @if (user.isDeleted) {
                      <span class="badge bg-danger">Deleted</span>
                    } @else if (user.deleteDateTimestamp > 0) {
                      <span class="badge bg-warning">Delete in progress</span>
                    }
                  </td>
                  <td>
                    <div class="btn-group">
                      <button class="btn btn-sm btn-primary" type="button" routerLink="/backoffice/management/user-details" [queryParams]="{ id: user.userId }" tooltip="Details" placement="top"><i class="fa fa-search"></i></button>
                      <button class="btn btn-sm btn-warning" type="button" (click)="onClickAddCurrency(user.userId)" tooltip="Add currency" placement="top"><i class="fa fa-money"></i></button>
                      <button class="btn btn-sm btn-success" type="button" (click)="onClickAddExperience(user.userId)" tooltip="Add experience" placement="top"><i class="fa fa-star"></i></button>
                    </div>
                    @if (!user.isDeleted && user.deleteDateTimestamp === 0) {
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteUser(user.userId)" tooltip="Delete user" placement="top"><i class="fa fa-trash"></i></button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + users.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="users.length < resultsPerPage">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="users.length < resultsPerPage">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

        </tab>
        <tab heading="Statistics" (selectTab)="onSelectStatisticsTab()">
          <app-users-statistics-tab #statisticsTab></app-users-statistics-tab>
        </tab>
        <tab heading="Configurations">
          <app-configurations-block [configurations]="usersConfigurations" [collapsible]="false" />
        </tab>
      </tabset>
    </div>
  </div>
</div>